<ion-grid>
    <ion-row>
        <ng-content></ng-content>
    </ion-row>
</ion-grid>